import * as Types from './workstationStateActionTypes.js'

const initialState = {
    workstationsWithScissorStatusInfo: []
};

export default function workstationState(state = initialState, action) {
    switch (action.type) {
      
        case Types.SET_WORKSTATIONWITHSCISSORSTATUSINFO:
            if (state.workstationsWithScissorStatusInfo !== action.workstationsWithScissorStatusInfo) {
                return Object.assign({}, state, { workstationsWithScissorStatusInfo: action.workstationsWithScissorStatusInfo });
            }
            return state;
        default:
            return state;
    }
}